export const mmFormConstants={
    translationGroup:"_form"

}